export default {"src":"/_next/static/media/HON.3bdc9abe.svg","height":18,"width":18};